const icmsTaxType = {
  '00': 'Impostos completos', // '完全纳税（正常征税）',Impostos completos (impostos normais)
  20: 'Redução fiscal', // '减税基础（部分减免）', Redução fiscal (parcial)
  40: 'isento de impostos', // '免税',isento de impostos
  41: 'Sem impostos', // '不征税',Sem impostos
  51: 'Atraso fiscal', // '税收延期',Atraso fiscal
  60: 'Substituição do contribuinte confirmada', // '纳税人替代已确认',Substituição do contribuinte confirmada
  90: 'Outros' // '其他',Outros
};
const transportMode = {
  '01': 'Rodoviário', // Rodoviário 公路运输
  '1': 'Rodoviário', // Rodoviário 公路运输
  '02': 'Aéreo', // Aéreo 航空运输
  '03': 'Aquaviário', // Aquaviário 水路运输
  '04': 'Ferroviário', // Ferroviário 铁路运输
  '05': 'Dutoviário', // Dutoviário 管道运输
  '06': 'Multimodal' // Multimodal 多式联运
};
const documentType = {
  0: 'Normal', // 'CT-e 普通（Normal）',
  1: 'Complemento de Valores', // 'CT-e 价值补充（Complemento de Valores）',
  2: 'Anulação', // 'CT-e 撤销（Anulação）',
  3: 'Substituto' // 'CT-e 替代（Substituto）'
};
const serviceType = {
  0: 'Normal', // 正常的运输服务',
  1: 'Subcontratação', // 分包/转包运输',
  2: 'Redespacho', // 重新发送/重定向',
  3: 'Redespacho Intermediário', // 中间重定向运输',
  4: 'Serviço Vinculado a Multimodal', // 与多式联运相关的服务',
  5: 'Transporte de Carga de Pessoas', // 载货运输服务',
  6: 'Transporte de Pessoas', // 人员运输（针对 CT-e OS）',
  7: 'Transporte de Valores', // 贵重物品运输（针对 CT-e OS）',
  8: 'Excesso de Bagagem' // 行李超重（针对 CT-e OS）'
};
const mdfecfop = {
  5351: 'Prestação de serviços de transporte para serviços semelhantes.',
  5352: 'Prestação de serviços de transporte a empresas industriais',
  5353: 'Prestação de serviços de transporte a empresas comerciais',
  5354: 'Prestação de serviços de transporte a prestadores de serviços de comunicação.',
  5355: 'Prestação de serviços de transporte a empresas de energia elétrica',
  5356: 'Prestação de serviços de transporte aos produtores agrícolas',
  5357: 'Prestação de serviços de transporte a não contribuintes',
  5359: 'Serviços de transporte de mercadorias livres de fatura',
  5360: 'Prestação de serviços de transporte a empresas tributárias em nome',
  5932: 'Local de início do serviço diferente do local de registro da transportadora (dentro do estado)',
  6351: 'Transporte transestatal para serviços semelhantes',
  6352: 'Transporte transestatal para empresas industriais',
  6353: 'Transporte transestatal para empresas comerciais',
  6354: 'Transporte transestatal para prestadores de serviços de comunicação',
  6355: 'Transporte transestatal para empresas elétricas',
  6356: 'Transporte transestatal para produtores agrícolas',
  6357: 'Transporte transestatal para não contribuintes',
  6359: 'Transporte transnacional sem fatura de mercadorias transportadas',
  6360: 'Transporte transestatal para empresas tributárias',
  6932: 'Local de início do serviço diferente do local de registro (interestadual)'
};
export { icmsTaxType, transportMode, documentType, serviceType, mdfecfop };
